// extracted by mini-css-extract-plugin
module.exports = {"debug":"DoNotTrack_debug","placeholder":"DoNotTrack_placeholder"};